import { usePlanFeaturesQuery } from '@/hooks/queries/use-plan-features-query';
import type { PlanQuotaMeta } from '@fluenceur/types';

/**
 * The organization's gifting invitations this month, as `GET /dashboard/features`
 * states them. Undefined while the features load; a plan that counts nothing
 * answers a null `limit`.
 */
export function useGiftingInvitationQuota(): PlanQuotaMeta | undefined {
  const { data } = usePlanFeaturesQuery();
  return data?.giftingInvitations;
}

/** How many gifting invitations the month still allows; null when nothing is counted. */
export function giftingInvitationsLeft(quota: PlanQuotaMeta | undefined): number | null {
  if (!quota || quota.limit === null) return null;
  return Math.max(0, quota.limit - quota.used);
}
